angular.module('app').controller('SubjectsCtrl', function($controller, $scope, $http) {
    "ngInject";

    var main = this;
    main.name = 'event_signup';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));
    main.showModelGrid = false;

    main.query.order = 'last_name';

    main.update_photographed_status = function(item) {
        $http.put('/api/v1/admin/event_signup/' + item.id, {'not_photographed': item.not_photographed, 'not_photographed_notes': item.not_photographed_notes, 'event_id': item.event.id})
    }

    main.toggleModelGrid = function() {
        main.showModelGrid = !main.showModelGrid;

        if(main.showModelGrid) {
            main.query.subject__model_release = true;
        } else {
            main.query.subject__model_release = null;
        }
        console.log(main.query);

        main.load();

    }

    main.prepareQuery = function() {
        var params = main._prepareQuery();
        if(main.showModelGrid) {
            params.includePhotos = 1;
        }
        return params;
    }
});

